export function buildApiUrl(base, from, to) {
  const sep = base.indexOf('?') !== -1 ? '&' : '?'
  return base + sep + 'from=' + encodeURIComponent(from) + '&to=' + encodeURIComponent(to)
}

export function isValidApiResponse(data) {
  return data && Array.isArray(data) && data.length > 0 && typeof data.message === 'undefined'
}

export function parseApiResponse(rawData) {
  const metalMap = {}

  rawData.forEach(item => {
    if (!metalMap[item.Code]) {
      metalMap[item.Code] = { code: item.Code, prices: {} }
    }

    const sortedPrices = item.Prices.slice().sort((a, b) =>
      new Date(a.TradeTime) - new Date(b.TradeTime)
    )

    sortedPrices.forEach(price => {
      const currency = price.Currency.toLowerCase()
      if (!metalMap[item.Code].prices[currency]) {
        metalMap[item.Code].prices[currency] = []
      }

      const d = new Date(price.TradeTime)
      const dateKey = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
      const existing = metalMap[item.Code].prices[currency]

      if (existing.some(e => e.dateKey === dateKey))
        return

      existing.push({
        dateKey,
        dateLabel: d.getDate() + '.' + (d.getMonth() + 1) + '.' + String(d.getFullYear()).slice(-2),
        rawDate: d,
        pricePerGram: price.BidGram,
        pricePerOunce: price.BidGram * 31.105
      })
    })
  })

  Object.values(metalMap).forEach(metal => {
    Object.values(metal.prices).forEach(arr => {
      arr.sort((a, b) => a.rawDate - b.rawDate)
    })
  })

  return Object.values(metalMap)
}
